module.exports = __webpack_public_path__ + "media/assets/omniauth-google-logo-6e43bb373d9484e7d630832ade2c51dd.svg";